<script setup>
import { computed } from "vue";
import { usePage, Link } from "@inertiajs/vue3";
import SidenavWithSubmenu from "./SidenavWithSubmenu.vue";

const menus = computed(() => usePage().props.menus);
const activeMenuCode = computed(() => usePage().props.activeMenuCode);

const appBaseUrl = usePage().props.appBaseUrl + "/admin";

const toogleSidebar = () => {
    document.body.classList.toggle("sb-sidenav-toggled");
    localStorage.setItem(
        "sb|sidebar-toggle",
        document.body.classList.contains("sb-sidenav-toggled")
    );
};
</script>

<template>
    <div id="layoutSidenav_nav">
        <nav
            class="sb-sidenav accordion sb-sidenav-dark bg-germplasm-red"
            id="sidenavAccordion"
        >
            <div class="sb-sidenav-menu pt-2">
                <div class="nav pt-3">
                    <template v-for="menu in menus" :key="menu.id">
                        <!-- MENU TYPE LINK -->
                        <Link
                            v-if="menu.type == 0"
                            class="nav-link"
                            :class="{
                                active: activeMenuCode == menu.code,
                            }"
                            :href="appBaseUrl + '/' + menu.code"
                            preserve-state
                        >
                            <div class="sb-nav-link-icon">
                                <span class="material-icons">{{
                                    menu.icon
                                }}</span>
                            </div>
                            {{ menu.name }}
                        </Link>

                        <!-- MENU TYPE HEADER -->
                        <div
                            v-if="menu.type == 1"
                            class="sb-sidenav-menu-heading"
                        >
                            {{ menu.name }}
                        </div>

                        <!-- MENU TYPE WITH CHILDREN -->
                        <SidenavWithSubmenu
                            v-if="menu.type == 2"
                            :menu="menu"
                        />
                    </template>
                </div>
            </div>
        </nav>
    </div>
</template>

<style scoped>
.task-notif {
    margin-left: auto;
}
</style>
